module.exports = __webpack_public_path__ + "img/94.ca60ad45.jpg";